import { colors } from '#base/js/variables.style'
import { useStyles } from './confidence-plot.style'

const STROKE_WIDTH = 2

export const POINT_RADIUS = 4
export const POINT_RADIUS_LARGER = 5 // Larger point when no confidence range
export const ARROW_WIDTH = 7
export const ARROW_HEIGHT = 6

export const PLOT_TYPE = {
  FILLED: 'filled',
  CIRCLE: 'circle'
}

export function ConfidencePlot ({
  value,
  ciLo,
  ciHi,
  xScale,
  y,
  type = PLOT_TYPE.FILLED,
  color,
  label
}) {
  const classes = useStyles()

  const hasCILo = ciLo !== null && ciLo !== undefined
  const hasCIHi = ciHi !== null && ciHi !== undefined
  const domain = xScale.domain()

  let displayCiHi = ciHi
  let showArrowRight = false
  if (hasCIHi && ciHi > domain[1]) {
    displayCiHi = domain[1]
    showArrowRight = true
  }

  let displayCiLo = ciLo
  let showArrowLeft = false
  if (hasCILo && ciLo < domain[0]) {
    displayCiLo = domain[0]
    showArrowLeft = true
  }

  const shouldShowFullCI =
    hasCILo &&
    hasCIHi &&
    displayCiLo <= displayCiHi &&
    (displayCiLo < domain[1] || displayCiHi >= domain[0])
  const shouldShowLoOnlyCI = hasCILo && !hasCIHi
  const shouldShowHiOnlyCI = hasCIHi && !hasCILo
  const shouldShowAnyCI =
    shouldShowFullCI || shouldShowLoOnlyCI || shouldShowHiOnlyCI

  // Only show the point if it is within the domain bounds
  const shouldShowPoint =
    value !== undefined && value >= domain[0] && value <= domain[1]

  const pointRadius = shouldShowAnyCI ? POINT_RADIUS : POINT_RADIUS_LARGER

  if (value === undefined || value === null || !y || !xScale) {
    return null
  }

  return (
    <>
      {showArrowLeft && <LeftArrow x={xScale(domain[0])} y={y} color={color} />}
      {showArrowRight && (
        <RightArrow x={xScale(domain[1])} y={y} color={color} />
      )}
      {shouldShowFullCI && (
        <line
          stroke={color}
          strokeWidth={pointRadius / 2}
          x1={xScale(displayCiLo)}
          y1={y}
          x2={xScale(displayCiHi)}
          y2={y}
        />
      )}
      {shouldShowLoOnlyCI && (
        <line
          stroke={color}
          strokeWidth={pointRadius / 2}
          x1={xScale(displayCiLo)}
          y1={y}
          x2={xScale(value)}
          y2={y}
        />
      )}
      {shouldShowHiOnlyCI && (
        <line
          stroke={color}
          strokeWidth={pointRadius / 2}
          x1={xScale(value)}
          y1={y}
          x2={xScale(displayCiHi)}
          y2={y}
        />
      )}
      {label && (
        <text className={classes.pointLabel} x={xScale(value)} y={y - 8}>
          {label}
        </text>
      )}
      {shouldShowPoint && type === PLOT_TYPE.FILLED && (
        <circle r={pointRadius} fill={color} cx={xScale(value)} cy={y} />
      )}
      {shouldShowPoint && type === PLOT_TYPE.CIRCLE && (
        <circle
          r={pointRadius - 1}
          fill={'var(--theme-background)'}
          stroke={color}
          strokeWidth={STROKE_WIDTH}
          cx={xScale(value)}
          cy={y}
        />
      )}
    </>
  )
}

function LeftArrow ({ x, y, color }) {
  return (
    <polygon
      points={`${x} ${y + ARROW_HEIGHT / 2}, ${x - ARROW_WIDTH} ${y}, ${x} ${
        y - ARROW_HEIGHT / 2
      }`}
      fill={color}
    />
  )
}

function RightArrow ({ x, y, color }) {
  return (
    <polygon
      points={`${x} ${y - ARROW_HEIGHT / 2}, ${x + ARROW_WIDTH} ${y}, ${x} ${
        y + ARROW_HEIGHT / 2
      }`}
      fill={color}
    />
  )
}
